import { createSlice } from '@reduxjs/toolkit';
import { LoginTypeProps } from './types';

export const initialState: LoginTypeProps = {
  fetching: false,
  loginError: false,
  googleLoginFetching: false,
};

export const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getLoginRequest(state, _action) {
      state.fetching = true;
      state.loginError = false;
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getLoginSuccess(state, action) {
      state.fetching = false;
      state.loginError = false;
    },
    getLoginError(state, action) {
      state.fetching = false;
      state.loginError = action.payload;
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getGoogleLoginRequest(state, _action) {
      state.googleLoginFetching = true;
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getGoogleLoginSuccess(state, _action) {
      state.googleLoginFetching = false;
    },
    getGoogleLoginError(state, action) {
      state.googleLoginFetching = false;
      state.loginError = action.payload;
    },
  },
  extraReducers: {},
});

export const { actions } = loginSlice;

export default loginSlice.reducer;
